import { LogOut, ShieldX, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { formatSystemDate } from "@/lib/date-only";

interface Props {
  removedAt: string;
  removedReason: string | null;
}

export default function WorkspaceRemovedScreen({ removedAt, removedReason }: Props) {
  const handleSignOut = async () => {
    await supabase.auth.signOut();
    window.location.replace("/app?login=1");
  };

  const reasonText =
    removedReason === "owner_removed"
      ? "O titular do workspace removeu seu acesso."
      : removedReason === "plan_downgrade"
        ? "O plano do workspace foi alterado e seu acesso foi revogado."
        : "Seu acesso ao workspace foi encerrado.";

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <div className="mx-auto w-full max-w-md space-y-6 rounded-2xl border bg-card p-8 shadow-lg">
        <div className="flex flex-col items-center gap-4 text-center">
          <div className="rounded-full bg-destructive/10 p-4">
            <ShieldX className="h-8 w-8 text-destructive" />
          </div>

          <h1 className="text-xl font-semibold text-foreground">Acesso ao workspace encerrado</h1>

          <p className="text-sm text-muted-foreground">{reasonText}</p>

          <p className="text-xs text-muted-foreground">
            Removido em {formatSystemDate(removedAt)}.
          </p>
        </div>

        <div className="space-y-3">
          <div className="rounded-lg border border-primary/15 bg-primary/5 p-4">
            <div className="flex items-start gap-3">
              <UserPlus className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
              <div className="space-y-1">
                <p className="text-sm font-medium text-primary">Quer continuar usando o DailyFi?</p>
                <p className="text-xs text-primary/80">
                  Você pode contratar um plano individual e começar com um workspace próprio.
                  Seus dados anteriores não serão transferidos por questões de privacidade.
                </p>
              </div>
            </div>
          </div>

          <Button className="w-full gap-2" onClick={handleSignOut}>
            <LogOut className="h-4 w-4" />
            Sair e contratar meu plano
          </Button>

          <Button variant="ghost" className="w-full text-muted-foreground" onClick={handleSignOut}>
            Sair
          </Button>
        </div>
      </div>
    </div>
  );
}
